import { render } from "./PlotOrderTemplatePage.vue?vue&type=template&id=d6126362&ts=true"
import script from "./PlotOrderTemplatePage.ts?vue&type=script&lang=ts&external"
export * from "./PlotOrderTemplatePage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__